import React from "react";
import toast from 'toasted-notes' 
import 'toasted-notes/src/styles.css';

class Signout extends React.Component {
  constructor(props) {
    super(props);
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('access_token');
    toast.notify('You have been successfully logged out');
    this.props.history.push('/');
  }

  render() {
    return null;
  }
}
export default Signout;
